import React from "react";
import { Container } from "@mui/material";
import {Route, Switch} from "react-router";
import {useAppSelector} from "../store";
import { AuthStep } from "../store/auth/auth.reducer";
import DownloadDocumentPrerequis from "./shared/documentPrerequis/DownloadDocumentPrerequis";
import GenericSollicitationForm from "./shared/GenericSollicitationForm";
import {Loader} from "./Loader";
import NotAuthorized from "./expert/notAuthorized";

interface AppProps {
	idTechPsCible: string | null;
}

function App({ idTechPsCible }: AppProps) {
	const isAuth = useAppSelector((s) => s.auth.step === AuthStep.Connected);
	const isAdminMode = useAppSelector((s) => s.auth.isAdminMode);

// Gère l’accès à /expert avec vérification des droits admin via la paramètre optionnel idTechPsCible
	const renderExpertRoute = () => {
		if (idTechPsCible) {
			if (isAdminMode == null) {
				return <Loader />;
			}
			if (!isAdminMode) {
				return <NotAuthorized />;
			}
		}
		return <GenericSollicitationForm mode="Expert" />;
	};

	if (!isAuth) return null;

	return (
		<Container className="App" sx={{ height: "100%" }}>
			<Switch>
				<Route exact path="/expert" render={renderExpertRoute} />
				<Route
					exact
					path={"/:type(expert|ressource)/download/:idDocument?"}
					render={() => <DownloadDocumentPrerequis/>}
				></Route>
				<Route exact path="/ressource" render={()=> <GenericSollicitationForm mode="EquipeRessource" /> } />
			</Switch>
		</Container>
	);
}

export default App;